module.exports = __webpack_public_path__ + "static/media/Donations_5.c8a59c49.jpg";